// ============================================================================
// Platform Utilities
// ============================================================================

export interface PlatformInfo {
  name: string;
  emoji: string;
  bgClass: string;
}

const PLATFORM_MAP: Record<string, PlatformInfo> = {
  x: {name: "X", emoji: "𝕏", bgClass: "bg-black"},
  twitter: {name: "X", emoji: "𝕏", bgClass: "bg-black"},
  "x.com": {name: "X", emoji: "𝕏", bgClass: "bg-black"},
  instagram: {
    name: "Instagram",
    emoji: "📷",
    bgClass: "bg-gradient-to-tr from-purple-500 via-pink-500 to-orange-400",
  },
  facebook: {name: "Facebook", emoji: "📘", bgClass: "bg-blue-600"},
  linkedin: {name: "LinkedIn", emoji: "💼", bgClass: "bg-blue-700"},
  youtube: {name: "YouTube", emoji: "📺", bgClass: "bg-red-600"},
  tiktok: {name: "TikTok", emoji: "🎵", bgClass: "bg-black"},
};

/**
 * Get platform display info from platform name or URL
 * @example getPlatformInfo("twitter") => {name: "X", emoji: "𝕏", bgClass: "bg-black"}
 */
export function getPlatformInfo(platform: string | null | undefined): PlatformInfo | null {
  if (!platform) return null;

  const p = platform.toLowerCase();

  // Check for exact match or substring match
  for (const [key, info] of Object.entries(PLATFORM_MAP)) {
    if (p.includes(key)) {
      return info;
    }
  }

  return {name: "Web", emoji: "🌐", bgClass: "bg-gray-600"};
}

/**
 * Get a profile image URL, handling Twitter profile URLs via unavatar.io
 * @example getProfileImageUrl("https://twitter.com/user/photo") => "https://unavatar.io/twitter/user"
 */
export function getProfileImageUrl(profilePicture: string | null | undefined): string | null {
  if (!profilePicture) return null;

  // Handle Twitter photo URLs - convert to unavatar.io
  if (profilePicture.includes("twitter.com") && profilePicture.includes("/photo")) {
    const usernameMatch = profilePicture.match(/twitter\.com\/([^/]+)\/photo/);
    if (usernameMatch) {
      const username = usernameMatch[1];
      return `https://unavatar.io/twitter/${username}`;
    }
  }

  // Handle X.com photo URLs
  if (profilePicture.includes("x.com") && profilePicture.includes("/photo")) {
    const usernameMatch = profilePicture.match(/x\.com\/([^/]+)\/photo/);
    if (usernameMatch) {
      const username = usernameMatch[1];
      return `https://unavatar.io/twitter/${username}`;
    }
  }

  return profilePicture;
}
